export default __webpack_public_path__ + "static/media/my_obituary_page.faa84668.pdf";